"use client";

import DynamicContent from "@/app/DynamicContent";
import { NiceToMeetYou } from "@/components/NiceToMeetYou";
import { HomeWhatWeDo } from "@/components/pages/home/HomeWhatWeDo";
import ServicePageHero from "@/components/pages/service/ServicePageHero";
import { serviceMap } from "@/common/constants";
import CTAFooter from "components/Footer/CTAFooter";
import { usePageTransition } from "mono/third-party/react-page-transitions-custom";
import applyPageTransition from "lib/usePageTransition";

export default function ServicePage({ service, params }) {
  const { transitionState, from, to, data } = usePageTransition({
    ...applyPageTransition("SERVICE"),
  });

  return (
    <>
      <ServicePageHero
        title={serviceMap[service.slug]}
        header={service.header.headertext}
        paragraph={service.header.paragraph}
        cta={service.header.cta}
      />

      <DynamicContent content={service.content} page={service} />

      <HomeWhatWeDo currentService={service.slug} />
      <CTAFooter />
      <NiceToMeetYou />
    </>
  );
}
